export class RequisitosModel {
  constructor({ id, nome, tiposRequisito, requisitoSim, requisitoNao, textoRequisitoObservacao }) {
    this.id = id;
    this.nome = nome;
    this.tiposRequisito = tiposRequisito ? tiposRequisito : [],
    this.requisitoSim = requisitoSim,
    this.requisitoNao = requisitoNao,
    this.textoRequisitoObservacao = textoRequisitoObservacao
  }
}
